// extracted by mini-css-extract-plugin
module.exports = {"displayFix":"_04e48b55229cae5c27367433505411c9-less"};